import { ArticleSelectorDialogProps } from 'components/Common/ArticleSelector/ArticleSelectorDialog'
import { AssemblySimplificationDialogProps } from 'components/Common/AssemblySimplification/AssemblySimplificationDialog'
import { WorkingStepMultipleItemsDialogProps } from 'components/ProjectPage/BillOfMaterials/Rows/Components/RowWorkingSteps/WorkingSteps/WorkingStepMultipleItemsDialog'
import { BatchEditBomItemsDialogProps } from 'features/BillOfMaterials/BatchEditRowsDialog/BatchEditRowsDialog'
import { CuttingPlanDialogProps } from 'features/BillOfMaterials/MaterialHeader/ActiveCuttingPlanDialog'
import { CopyKeywordsDialogProps } from 'features/BillOfMaterials/SelectionSpeedDial/CopyKeywordsDialog/CopyKeywordsDialog'
import { CopyWorkingStepsDialogProps } from 'features/BillOfMaterials/SelectionSpeedDial/CopyWorkingStepsDialog/CopyWorkingStepsDialog'
import { DeleteWorkingStepsDialogProps } from 'features/BillOfMaterials/SelectionSpeedDial/DeleteWorkingStepsDialog/DeleteWorkingStepsDialog'
import { BomItemDetailsDrawerProps } from 'features/BomItemDetailsDrawer/BomItemDetailsDrawer'
import { ConfirmationDialogProps } from 'features/ConfirmationDialog/ConfirmationDialog'
import { CostPriceDetailsProps } from 'features/CostPriceDetails/CostPriceDetailsDialog'
import { EventLogsDialogProps } from 'features/EventLogs/components/EventLogsDialog'
import { ProjectOperationsProps } from 'features/GeometryLogs/ProjectOperationsLogsDrawer'
import { ProjectProvideRawMaterialSettingsDialogProps } from 'features/MaterialProvidedSettings/Project/ProjectProvideRawMaterialSettingsDialog'
import { PurchasingPartDialogProps } from 'features/PurchasingPartDetails/PurchasingPartDialog'
import { DraftRFQDialogProps } from 'features/RequestForQuotations/ProjectRFQ/DraftRFQDialog/DraftRFQDialog'
import { ManageRFQDialogProps } from 'features/RequestForQuotations/ProjectRFQ/RequestForQuotationsDialog/RequestForQuotationsDialog'
import { ManageQuotationResponseDialogProps } from 'features/RequestForQuotations/Quotation/QuotationResponse/QuotationResponseDialog/QuotationResponseDialog'
import { SalesRepresentativeDialogProps } from 'features/SalesRepresentative/components/SalesRepresentativeDialog'
import { SupportContactDialogProps } from 'features/SupportContactDialog/SupportContactDialog'
import { Action } from 'typesafe-actions'

export enum ProjectViews {
  NotInitialized = 0,
  DashboardView = 1,
  GridView = 2,
  BoMBoLView = 3,
  MaterialsView = 4,
  RoutesView = 5,
}

export type ModalTypes =
  | 'ArticleSelector'
  | 'AssemblySimplification'
  | 'BomItemDetailsDrawer'
  | 'EventLogs'
  | 'SalesRepresentative'
  | 'SupportContact'
  | 'CostPriceDetails'
  | 'CuttingPlanDetails'
  | 'ConfirmationDialog'
  | 'BatchEditBomItems'
  | 'ProjectOperations'
  | 'PurchasingPartDialog'
  | 'ProjectDetailsDialog'
  | 'CopyPasteDrawer'
  | 'ProjectMaterialEstimationSettingsDialog'
  | 'ReCreateProjectConfirmationDialog'
  | 'WorkingStepMultipleItemsDialog'
  | 'CopyWorkingStepsDialog'
  | 'CopyKeywordsDialog'
  | 'DeleteWorkingStepsDialog'
  | 'DraftRFQDialog'
  | 'ManageRFQDialog'
  | 'ManageQuotationResponseDialog'

export type ModalTypeProps =
  | ArticleSelectorDialogProps
  | AssemblySimplificationDialogProps
  | EventLogsDialogProps
  | SalesRepresentativeDialogProps
  | SupportContactDialogProps
  | CostPriceDetailsProps
  | CuttingPlanDialogProps
  | ConfirmationDialogProps
  | BatchEditBomItemsDialogProps
  | ProjectOperationsProps
  | BomItemDetailsDrawerProps
  | PurchasingPartDialogProps
  | ProjectProvideRawMaterialSettingsDialogProps
  | WorkingStepMultipleItemsDialogProps
  | CopyWorkingStepsDialogProps
  | CopyKeywordsDialogProps
  | DeleteWorkingStepsDialogProps
  | DraftRFQDialogProps
  | ManageRFQDialogProps
  | ManageQuotationResponseDialogProps

export type ModalTypePropsMap = {
  ArticleSelector: ArticleSelectorDialogProps
  BomItemDetailsV2: BomItemDetailsDrawerProps
  AssemblySimplification: AssemblySimplificationDialogProps
  BomItemDetailsDrawer: BomItemDetailsDrawerProps
  EventLogs: EventLogsDialogProps
  SalesRepresentative: SalesRepresentativeDialogProps
  SupportContact: SupportContactDialogProps
  CostPriceDetails: CostPriceDetailsProps
  CuttingPlanDetails: CuttingPlanDialogProps
  ConfirmationDialog: ConfirmationDialogProps
  BatchEditBomItems: BatchEditBomItemsDialogProps
  ProjectOperations: ProjectOperationsProps
  PurchasingPartDialog: PurchasingPartDialogProps
  ProjectDetailsDialog: ProjectOperationsProps
  ProjectMaterialEstimationSettingsDialog: ProjectProvideRawMaterialSettingsDialogProps
  CopyPasteDrawer: {}
  WorkingStepMultipleItemsDialog: WorkingStepMultipleItemsDialogProps
  CopyWorkingStepsDialog: CopyWorkingStepsDialogProps
  CopyKeywordsDialog: CopyKeywordsDialogProps
  DeleteWorkingStepsDialog: DeleteWorkingStepsDialogProps
  DraftRFQDialog: DraftRFQDialogProps
  ManageRFQDialog: ManageRFQDialogProps
  ManageQuotationResponseDialog: ManageQuotationResponseDialogProps
}

export type UIState = {
  Modals?: {
    CurrentModal: ModalTypes
    ModalProps: ModalTypeProps
  }
}

export enum UIActionNames {
  UploadProgress = 'ui/update_upload_progress',
  DeleteProgress = 'ui/delete_upload_progress',
  ChangeProjectView = 'ui/change_project_view',
  CollapseAllHeaders = 'ui/collapse_all_headers',
  ExpandAllHeaders = 'ui/expand_all_headers',
  CloseModal = 'CloseModal',
  OpenModal = 'OpenModal',
}

export interface ChangeProjectView extends Action {
  type: UIActionNames.ChangeProjectView
  view: ProjectViews
}

export interface SetUploadProgress extends Action {
  type: UIActionNames.UploadProgress
  operation: string
  progress: number
}

export interface DeleteUploadProgress extends Action {
  type: UIActionNames.DeleteProgress
  operation: string
}

export interface CollapseAllHeaders extends Action {
  type: UIActionNames.CollapseAllHeaders
}

export interface ExpandAllHeaders extends Action {
  type: UIActionNames.ExpandAllHeaders
}

export interface OpenModal extends Action {
  type: UIActionNames.OpenModal
  modalType: ModalTypes
  modalProps: ModalTypeProps
}

export interface CloseModal extends Action {
  type: UIActionNames.CloseModal
}

export type UIActionTypes =
  | SetUploadProgress
  | DeleteUploadProgress
  | ChangeProjectView
  | CollapseAllHeaders
  | ExpandAllHeaders
  | OpenModal
  | CloseModal
